module.exports = {"510921100":"赤城镇","510921101":"新会镇","510921102":"文井镇","510921103":"明月镇","510921104":"常乐镇","510921105":"天福镇","510921106":"红江镇","510921107":"宝梵镇","510921108":"大石镇","510921109":"吉祥镇","510921110":"鸣凤镇","510921111":"任隆镇","510921112":"三凤镇","510921113":"高坪镇","510921114":"蓬南镇","510921115":"群利镇","510921116":"吉星镇","510921117":"金桥镇","510921200":"下东乡","510921201":"新星乡","510921202":"罗戈乡","510921203":"板桥乡","510921204":"槐花乡","510921206":"黄泥乡","510921207":"荷叶乡","510921208":"金龙乡","510921209":"农兴乡","510921210":"新胜乡","510921211":"回水乡","510921212":"群力乡","510921213":"高升乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510921.json
// module id = 2319
// module chunks = 0